module.exports = __webpack_public_path__ + "img/vue.3cff1fd8.png";